import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

	const [lang, set_lang] = useState('pt');
    const [max_order, set_max_order] = useState(0);

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    const get_info = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                //console.log(res.data)
                setData(res.data);
                setLoading(false)
            })
            .catch(() => 404
        )

        await reqGET(api_list_order(getTokenInfo().companycode))
            .then(res => {
                //console.log(res.data)
                if(res.data[0]['max'] !== null)
                    set_max_order(res.data[0]['max'])
                //setLoading(false)
            })
            .catch(() => 404
        )
    }

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {
        get_info()

        set_lang(localStorage.getItem('lang'))

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            });
    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
    }

    const columns = [
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '40% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_category,
            selector: 'info.category',
            width: '15% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_observation,
            selector: 'info.observation',
            width: '15% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_price,
            selector: 'info.value.price',
            width: '15% !important',
            minWidth: '100px !important',
            cell: row => {
                return (
                    <>
                        {row.info.value.price + '€'}
                    </>
                )
            },
            sortable: true,
            right: true,
        },
        {
            name: language[lang].field_visivel,
            selector: 'status',
            width: '10% !important',
            minWidth: '100px !important',
            cell: row => (
                row.info.status ? 
                    <span className="badge rounded-0 bg-success">
                        <i className="bi bi-check-lg text-white fs-4"></i>
                    </span> 
                : 
                    <span className="badge rounded-0 bg-danger">
                        <i className="bi bi-x-lg text-white fs-4"></i>
                    </span>
            ),
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '5% !important',
            minWidth: '100px !important',
            cell: row => 
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                    permissions.edit ?
                        <Link className="button button-update" to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                            <i className="bi bi-pencil"></i>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.remove ?
                        <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                            <i className="bi bi-trash"></i>
                        </button>
                    :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };


    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };


    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].component_list}</h2>
                <p>{language[lang].component} / {language[lang].component_list}</p>
            </div>
        
            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                        
                            <div className="pb-10">
                                <div className="div-table">
                                {
                                        permissions.edit ?
                                    <div className="table-header text-end">
                                        <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist, state: { item: {order: max_order}} }}  >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    :<></>
                                    }
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
        
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}